import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded
    const body = $('body');

    // Reviews
    const reviewsWrapper = $('#hotel-reviews-wrapper');
    if (reviewsWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleReviewsResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const skeleton = $('#hotel-reviews-skeleton');
        const loadMoreButtonWrapper = $('#hotel-reviews-load-more-button-wrapper');
        let page = parseInt(reviewsWrapper.data('page'), 10);
        const perPage = parseInt(reviewsWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          reviewsWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_HOTEL_REVIEWS,
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  reviewsWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  reviewsWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                reviewsWrapper.data('page', page).attr('data-page', page);
                reviewsWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const loadMoreButton = $('#hotel-reviews-load-more-button');
      if (loadMoreButton.length) {
        loadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(reviewsWrapper.data('offset'), 10) || 0;

          handleReviewsResults(offset);
        });
      }

      const hotelReviewModal = $('.hotel-review-modal');
      if (hotelReviewModal.length) {
        const hotelReviewModalTitle = hotelReviewModal.find('.review-title');
        const hotelReviewModalText = hotelReviewModal.find('.review-text');
        const hotelReviewModalAuthor = hotelReviewModal.find('.review-author');

        $(document).on('click', '.review-modal-trigger', function(e) {
          e.preventDefault();

          const _this = $(this);
          const thisReviewCard = _this.closest('.review-card');
          const reviewTitle = thisReviewCard.find('.title').html();
          const reviewText = thisReviewCard.find('.full-text').html();
          const reviewAuthor = thisReviewCard.find('.author-name').html();

          hotelReviewModalTitle.html(reviewTitle);
          hotelReviewModalText.html(reviewText);
          hotelReviewModalAuthor.html('- ' + reviewAuthor);
          body.addClass('review-modal-open');

          return false;
        });

        $(document).on('click', '.review-modal-close', function(e) {
          e.preventDefault();

          body.removeClass('review-modal-open');
          hotelReviewModalTitle.html('');
          hotelReviewModalText.html('');
          hotelReviewModalAuthor.html('');

          return false;
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelReviews.js